var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},_vm._l((_vm.schedulingOptions),function(ref){
var title = ref.title;
var description = ref.description;
var name = ref.name;
var eventName = ref.eventName;
return _c('SchedulerSelector',{key:name,attrs:{"description":description,"title":title,"selected":_vm.selectorIsSelected(name),"disabled":_vm.selectorIsDisabled(name),"type":name},on:{"selected":function (p) { return _vm.$emit(eventName, p); }}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }